<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2022-06-30 14:27:59
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-07-06 18:09:06
 * @Description: 优惠券列表
 * @FilePath: /src/page/coupon/list.vue
-->
<template>
    <div class="page page-coupon-list">
        <div class="header-list">
            <div
                class="header-item"
                :class="{ select: availableStatus == 5 }"
                @click="(availableStatus = 5) && getList(1)"
            >
                可用
            </div>
            <div
                class="header-item"
                :class="{ select: availableStatus == -5 }"
                @click="(availableStatus = -5) && getList(1)"
            >
                不可用
            </div>
        </div>
        <div class="coupon-list">
            <div class="exchange-box" v-if="availableStatus == 5">
                <input
                    type="请输入兑换码"
                    class="input"
                    v-model="code"
                    placeholder="请输入兑换码"
                    @blur="inputBlur"
                />
                <div class="btn" @click="exchange">兑换</div>
            </div>
            <div
                class="coupon-item"
                :class="{ 'no-use': item.status != 0 }"
                v-for="(item, index) in couponList"
                :key="index"
            >
                <div class="coupon-info">
                    <div class="coupon-name">
                        <div class="coupon-tip">{{ item.typeDesc }}</div>
                        {{ item.cardName }}
                    </div>
                    <div class="coupon-time">
                        {{ item.availableBeginTimeDesc }} ~ {{ item.availableEndTimeDesc }}
                    </div>
                    <div class="price-box" v-if="!item.hidePriceBlock">
                        <div class="coupon-price">{{ item.cardAmount }}</div>
                        <div class="coupon-price-desc">{{ item.cardAvailableAmountDesc }}</div>
                    </div>
                </div>
                <div class="line"></div>
                <div class="coupon-other" :class="{ open: item.openLimit }">
                    <div class="use-limit" v-html="item.instruction"></div>
                    <div class="icon-down" @click="item.openLimit = !item.openLimit"></div>
                    <div class="btn-use" @click="$util.pageBack()">立即使用</div>
                </div>
                <img
                    class="icon-coupon-expired"
                    v-if="item.status == 5"
                    src="~@/assets/icons/icon-coupon-used.png"
                />
                <img
                    class="icon-coupon-expired"
                    v-else-if="item.status == -5"
                    src="~@/assets/icons/icon-coupon-expired.png"
                />
                <img
                    class="icon-coupon-expired"
                    v-else-if="item.status == -10"
                    src="~@/assets/icons/icon-coupon-voided.png"
                />
            </div>
            <Scroll :onBottom="onBottom" :lowerThreshold="200" />
        </div>
        <div class="no-list" v-if="couponList.length == 0">
            <img src="~@/assets/images/image-no-info.png" class="image" />
            <div class="tip">暂无信息</div>
        </div>
        <div class="dialog" v-if="dialog.status" @click="closeDialog">
            <div class="dialog-error" v-if="dialog.error">
                <div class="title">兑 · 换 · 失 · 败</div>
                <div class="message">{{ exchangeErrorMessage }}</div>
                <div class="tip">请检查后重新输入</div>
            </div>
            <div class="dialog-success" v-if="dialog.success">
                <div class="title">兑换成功</div>
                <div class="price">{{ exchangeCouponData.cardAmount }}</div>
                <div class="price-desc">{{ exchangeCouponData.cardAvailableAmountDesc }}</div>
                <div class="name">{{ exchangeCouponData.cardName }}</div>
                <div class="code">优惠码：{{ exchangeCouponData.code }}</div>
                <div class="time">有效期至{{ exchangeCouponData.availableEndTimeDesc }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Scroll from '@/components/scroll';
import { GET_MOVIE_COUPON_LIST, EXCHANGE_MOVIE_COUPON } from 'api';
export default {
    data() {
        return {
            availableStatus: 5,
            pageIndex: 1,
            pageSize: 20,
            isBottom: false,
            couponList: [],
            code: '',
            dialog: {
                status: false,
                success: false,
                error: false,
            },
            exchangeCouponData: {},
            exchangeErrorMessage: '',
        };
    },
    components: {
        Scroll,
    },
    created() {
        this.couponList = [];
        this.pageIndex = 1;
        this.getList();
    },
    methods: {
        getList(type = 0) {
            if (type == 1) {
                this.pageIndex = 1;
            }
            this.$util
                .post(GET_MOVIE_COUPON_LIST, {
                    availableStatus: this.availableStatus,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                })
                .then(res => {
                    if (res.success) {
                        for (let i = 0; i < res.data.length; i++) {
                            const item = res.data[i];
                            item.instruction = item.instruction.replace(/\n/g, '<br />');
                            item.availableBeginTimeDesc = moment(item.availableBeginTime).format(
                                'YYYY.M.D HH:mm'
                            );
                            item.availableEndTimeDesc = moment(item.availableEndTime).format(
                                'YYYY.M.D HH:mm'
                            );
                            item.openLimit = false;
                        }
                        if (res.data.length < this.pageSize) {
                            this.isBottom = true;
                        } else {
                            this.isBottom = false;
                        }
                        if (type == 0) {
                            this.couponList = [...this.couponList, ...res.data];
                        } else {
                            this.couponList = res.data;
                        }
                    }
                });
        },
        exchange() {
            if (!this.code) {
                return;
            }
            this.$util
                .post(
                    EXCHANGE_MOVIE_COUPON,
                    {
                        code: this.code,
                    },
                    {
                        hideMessage: true,
                    }
                )
                .then(res => {
                    if (res.success) {
                        this.code = '';
                        res.data.availableEndTimeDesc = moment(res.data.availableEndTime).format(
                            'YYYY.M.D HH:mm'
                        );
                        this.exchangeCouponData = res.data;
                        this.dialog.status = true;
                        this.dialog.success = true;
                        this.getList(1);
                    } else {
                        this.exchangeErrorMessage = res.message;
                        this.dialog.status = true;
                        this.dialog.error = true;
                    }
                });
        },
        closeDialog() {
            for (let k in this.dialog) {
                this.dialog[k] = false;
            }
        },
        // 触底事件
        onBottom() {
            if (this.isBottom) {
                return;
            }
            this.pageIndex++;
            this.getList();
        },
        //
        inputBlur() {
            setTimeout(() => {
                var scrollHeight =
                    document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
    },
};
</script>

<style lang="less" scoped>
@import url('~@/lib/base');
.page-coupon-list {
    padding-top: .pxToRem(88) [];
    min-height: 100vh;
    box-sizing: border-box;
    .header-list {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        .jc-sb;
        z-index: 100;
        background: white;
        .header-item {
            flex: 1;
            height: .pxToRem(88) [];
            line-height: .pxToRem(88) [];
            text-align: center;
            font-size: .pxToRem(30) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.5);
            &.select {
                font-weight: 600;
                color: rgba(0, 0, 0, 0.9);
                &::before {
                    content: ' ';
                    .base-center-x;
                    bottom: .pxToRem(7) [];
                    .sq(10);
                    background: #f8c32f;
                    border-radius: 100%;
                }
            }
        }
    }
    .coupon-list {
        .exchange-box {
            display: flex;
            width: .pxToRem(690) [];
            height: .pxToRem(88) [];
            line-height: .pxToRem(88) [];
            background: rgba(0, 0, 0, 0.05);
            border-radius: .pxToRem(44) [];
            margin: 0 auto;
            margin-top: .pxToRem(20) [];
            .input {
                flex: 1;
                background: rgba(0, 0, 0, 0);
                margin-left: .pxToRem(40) [];
            }
            .btn {
                width: .pxToRem(130) [];
                text-align: center;
                font-size: .pxToRem(30) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
            }
        }
        .coupon-item {
            background: white;
            margin: .pxToRem(20) [] .pxToRem(30) [] 0;
            border-radius: .pxToRem(40) [];
            box-shadow: .pxToRem(2) [] .pxToRem(5) [] .pxToRem(30) [] .pxToRem(0) []
                rgba(0, 0, 0, 0.08);
            .coupon-info {
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: .pxToRem(164) [];
            }
            .coupon-name {
                margin-left: .pxToRem(30) [];
                font-size: .pxToRem(28) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(52) [];
                margin-top: .pxToRem(20)[];
                .coupon-tip {
                    display: inline-block;
                    height: .pxToRem(42) [];
                    line-height: .pxToRem(42) [];
                    font-size: .pxToRem(22) [];
                    color: white;
                    background: #dd3021;
                    padding: 0 .pxToRem(6) [];
                    border-radius: .pxToRem(6) [];
                }
            }
            .coupon-time {
                margin-left: .pxToRem(30) [];
                font-size: .pxToRem(22) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: .pxToRem(38) [];
                margin-top: .pxToRem(8)[];
            }
            .price-box {
                position: absolute;
                top: .pxToRem(20) [];
                right: .pxToRem(20) [];
                .sq(140);
                background: rgba(252, 219, 40, 0.1);
                border-radius: .pxToRem(30) [];
                border: .pxToRem(1) [] solid #f8c32f;
                box-sizing: border-box;
                .coupon-price {
                    text-align: center;
                    font-size: .pxToRem(64) [];
                    font-weight: bold;
                    color: #d90209;
                    line-height: .pxToRem(80) [];
                    margin-top: .pxToRem(12) [];
                    &::before {
                        content: '¥';
                        font-size: .pxToRem(36) [];
                        font-weight: bold;
                        color: #d90209;
                        line-height: .pxToRem(40) [];
                    }
                }
                .coupon-price-desc {
                    text-align: center;
                    font-size: .pxToRem(20) [];
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.5);
                    line-height: .pxToRem(38) [];
                }
            }
            .line {
                height: .pxToRem(30) [];
                &::before {
                    content: '';
                    .base-center;
                    width: 100%;
                    height: 0;
                    border-top: .pxToRem(1) [] dashed rgba(0, 0, 0, 0.5);
                }
            }
            .coupon-other {
                display: flex;
                justify-content: flex-start;
                min-height: .pxToRem(90) [];
                &.open {
                    .use-limit {
                        overflow: unset;
                    }
                    .icon-down {
                        transform: rotate(180deg);
                    }
                }
            }
            :not(.open) .use-limit {
                height: .pxToRem(38) [];
                .overflow(1);
            }
            .use-limit {
                display: inline-block;
                line-height: .pxToRem(38) [];
                margin: .pxToRem(18) [] 0 .pxToRem(28) [] .pxToRem(30) [];
                max-width: .pxToRem(288) [];
            }
            .icon-down {
                margin-top: .pxToRem(22) [];
                margin-left: .pxToRem(20) [];
                .sq(24);
                background: url('~@/assets/icons/icon-down.png');
                background-size: cover;
            }
            .icon-coupon-expired {
                display: none;
                .sq(96);
                position: absolute;
                top: .pxToRem(90) [];
                right: .pxToRem(150) [];
            }
            .btn-use {
                position: absolute;
                top: .pxToRem(6) [];
                right: .pxToRem(30) [];
                text-align: center;
                width: .pxToRem(160) [];
                height: .pxToRem(60) [];
                line-height: .pxToRem(60) [];
                background: #fcdb28;
                border-radius: .pxToRem(30) [];
            }
            &.no-use {
                .use-limit {
                    color: rgba(0, 0, 0, 0.5);
                }
                .coupon-price {
                    color: rgba(0, 0, 0, 0.1);
                    &::before {
                        color: rgba(0, 0, 0, 0.1);
                    }
                }
                .coupon-price-desc {
                    color: rgba(0, 0, 0, 0.1);
                }
                .price-box {
                    background: #f2f2f2;
                    border: .pxToRem(1) [] solid #d9d9d9;
                }
                .icon-coupon-expired {
                    display: unset;
                }
                .btn-use {
                    display: none;
                }
            }
        }
    }
    .no-list {
        position: fixed;
        .base-center;
        .image {
            width: .pxToRem(240) [];
            height: .pxToRem(240) [];
        }
        .tip {
            text-align: center;
            margin-top: .pxToRem(16) [];
            font-size: .pxToRem(28) [];
            font-weight: 400;
            color: rgba(0, 0, 0, 0.5);
            line-height: .pxToRem(44) [];
        }
    }
    .dialog {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 200;
        .dialog-error {
            .base-center;
            width: .pxToRem(618) [];
            height: .pxToRem(444) [];
            background: url('~@/assets/images/image-exchange-error-bg.png');
            background-size: cover;
            .title {
                width: 100%;
                text-align: center;
                margin-top: .pxToRem(124) [];
                font-size: .pxToRem(26) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(40) [];
            }
            .message {
                width: 100%;
                padding: 0 .pxToRem(100) [];
                text-align: center;
                font-size: .pxToRem(36) [];
                font-weight: 400;
                color: #d90209;
                line-height: .pxToRem(42) [];
                margin-top: .pxToRem(24) [];
                box-sizing: border-box;
            }
            .tip {
                width: 100%;
                text-align: center;
                font-size: .pxToRem(26) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(40) [];
                margin-top: .pxToRem(24) [];
            }
        }
        .dialog-success {
            .base-center;
            width: .pxToRem(700) [];
            height: .pxToRem(900) [];
            background: url('~@/assets/images/image-exchange-success-bg.png');
            background-size: cover;
            .title {
                width: 100%;
                text-align: center;
                margin-top: .pxToRem(137) [];
                line-height: .pxToRem(36) [];
                font-size: .pxToRem(32) [];
            }
            .price {
                width: 100%;
                text-align: center;
                margin-top: .pxToRem(75) [];
                font-size: .pxToRem(200) [];
                font-weight: 600;
                color: #d90209;
                line-height: .pxToRem(200) [];
                &::after {
                    content: '元';
                    font-size: .pxToRem(50) [];
                    font-weight: 600;
                    color: #d90209;
                    line-height: .pxToRem(70) [];
                }
            }
            .price-desc {
                width: 100%;
                text-align: center;
                font-size: .pxToRem(36) [];
                font-weight: 400;
                color: #d90209;
                line-height: .pxToRem(50) [];
            }
            .name {
                margin-top: .pxToRem(82) [];
                width: 100%;
                text-align: center;
                font-size: .pxToRem(32) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.9);
                line-height: .pxToRem(52) [];
            }
            .code {
                margin-top: .pxToRem(4) [];
                width: 100%;
                text-align: center;
                font-size: .pxToRem(24) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: .pxToRem(38) [];
            }
            .time {
                width: 100%;
                text-align: center;
                font-size: .pxToRem(24) [];
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: .pxToRem(38) [];
            }
        }
    }
}
</style>
